export default __webpack_public_path__ + "static/helveticaneue-d5d60cee21914123357542f32b0c6754.woff2";